<template>
    <div class="pn-tela">
        <!-- cabeçalho: de quem são as notas e atalhos -->
        <div class="pn-cabecalho">
            <div class="pn-cabecalho__topo">
                <div class="pn-identidade">
                    <div class="pn-identidade__avatar" aria-hidden="true">{{ iniciaisInscrito }}</div>
                    <div class="pn-identidade__texto">
                        <span class="pn-identidade__sobre">Notas do webhook #{{ webhook.id }}</span>
                        <h2 class="pn-identidade__nome">{{ nomeInscrito }}</h2>
                        <div class="pn-identidade__selos">
                            <span class="badge badge-primary">{{ descricaoTipoWebhook(webhook.tipoeventoaviso) }}</span>
                            <span v-if="naoLidas>0" class="badge badge-warning">{{ naoLidas }} não lida{{ naoLidas>1 ? 's' : '' }}</span>
                            <span v-else class="badge badge-success"><b-icon icon="check2-all"></b-icon> Tudo lido</span>
                        </div>
                    </div>
                </div>

                <div class="pn-acoes">
                    <a class="btn btn-outline-primary" :href="urlCrm" target="_blank" rel="noopener">
                        <b-icon icon="box-arrow-up-right"></b-icon> Ver no CRM
                    </a>
                    <a class="btn btn-primary" :href="'/Access/Unity/Unitie/'+unitie.id+'/captacao/wh/'+webhook.id">
                        <b-icon icon="eye"></b-icon> Abrir webhook
                    </a>
                </div>
            </div>

            <dl class="pn-resumo">
                <div class="pn-resumo__item">
                    <dt>Contato CRM</dt>
                    <dd>{{ valor(webhook.contatoid) }}</dd>
                </div>
                <div class="pn-resumo__item">
                    <dt>Reg. CRM</dt>
                    <dd>{{ valor(webhook.registroprocesso) }}</dd>
                </div>
                <div class="pn-resumo__item">
                    <dt>Oferta</dt>
                    <dd>{{ valor(webhook.codigooferta) }}</dd>
                </div>
                <div class="pn-resumo__item">
                    <dt>Ano/semestre</dt>
                    <dd>{{ oferta && oferta.anoinicio ? oferta.anoinicio+'/'+oferta.semestreinicio : '—' }}</dd>
                </div>
                <div class="pn-resumo__item pn-resumo__item--largo">
                    <dt>Turma</dt>
                    <dd>{{ valor(oferta ? (oferta.descricaocompleta || oferta.descricaoturma) : null) }}</dd>
                </div>
            </dl>
        </div>

        <section class="ec-card">
            <header class="ec-card__cabecalho">
                <span class="ec-card__icone"><b-icon icon="bell"></b-icon></span>
                <div class="ec-card__textos">
                    <h2 class="ec-card__titulo">Notas do processamento</h2>
                    <p class="ec-card__subtitulo">Avisos gerados ao enviar este webhook para o ERP e o CRM. Os mais recentes aparecem primeiro.</p>
                </div>
            </header>
            <div class="ec-card__corpo">
                <notas-webhook :unidade-id="unitie.id" :webhook-id="webhook.id" :notas-iniciais="notas || []" @nao-lidas="naoLidas = $event"></notas-webhook>
            </div>
        </section>
    </div>
</template>

<script>
import NotasWebhook from './NotasWebhook.vue'

export default {
    components: { NotasWebhook },
    props: ['unitie', 'usuarioLogado', 'webhook', 'notas', 'oferta'],
    data(){
        return {
            naoLidas: 0,
        }
    },
    computed: {
        nomeInscrito(){
            return (this.webhook.nomeinscrito || 'Inscrito sem nome').toString()
        },
        iniciaisInscrito(){
            let partes = this.nomeInscrito.trim().split(/\s+/)
            return ((partes[0] || '').charAt(0) + (partes.length>1 ? partes[partes.length-1].charAt(0) : '')).toUpperCase()
        },
        urlCrm(){
            return 'https://crmsantamarcelina.apprubeus.com.br/contato/'+this.webhook.contatoid+'/registro/'+this.webhook.registroprocesso
        },
    },
    methods: {
        valor(v){
            return (v === null || v === undefined || v === '') ? '—' : v
        },
        descricaoTipoWebhook(tipo){
            return {
                c: 'Inscrição Confirmada',
                a: 'Contrato Assinado',
                m: 'Matriculado',
                v: 'Envia Valor CRM',
                f: 'Atualização Cadastral',
                EnviaMatriculaCrm: 'Enviar Matrícula CRM',
                d: 'Documentos',
            }[tipo] || 'Outros'
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.pn-tela {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pn-cabecalho {
    padding: 1.25rem;
    background: #fff;
    border: 1px solid $ec-borda;
    border-radius: $border-radius-lg;
    box-shadow: $box-shadow-sm;
}

.pn-cabecalho__topo {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
}

.pn-identidade {
    display: flex;
    align-items: center;
    gap: .9rem;
    min-width: 0;
}

.pn-identidade__avatar {
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1.1rem;
    color: #fff;
    background: linear-gradient(135deg, $ec-petroleo 0%, $ec-turquesa 100%);
}

.pn-identidade__texto { min-width: 0; }

.pn-identidade__sobre {
    font-size: .75rem;
    color: $ec-texto-suave;
}

.pn-identidade__nome {
    margin: .1rem 0 .4rem;
    font-size: 1.3rem;
    overflow-wrap: anywhere;
}

.pn-identidade__selos {
    display: flex;
    flex-wrap: wrap;
    gap: .35rem;
}

.pn-acoes {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
}

.pn-resumo {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: .75rem 1.25rem;
    margin: 1.1rem 0 0;
    padding: .9rem 1rem;
    background: $ec-fundo;
    border: 1px solid $ec-borda;
    border-radius: $border-radius-lg;
}

.pn-resumo__item {
    min-width: 0;

    &--largo { grid-column: span 2; }

    dt {
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: $ec-texto-suave;
        margin-bottom: .1rem;
    }

    dd {
        margin: 0;
        font-weight: 600;
        overflow-wrap: anywhere;
    }
}

.ec-card { margin-bottom: 0; }

@media (max-width: 575.98px) {
    .pn-cabecalho { padding: 1rem; }
    .pn-acoes { width: 100%; }
    .pn-acoes .btn { flex: 1; }
    .pn-resumo__item--largo { grid-column: auto; }
}
</style>
